import mm from 'micromatch'
import stringifyKeys from 'stringify-keys'

export default function getMatches(patterns, obj, opts) {
  const preparedPatterns = [].concat(patterns).map(pattern => pattern.replace(/\./g, '/'))
  const keys = stringifyKeys(obj, '/')
  const matches = mm(keys, preparedPatterns, opts)
  return matches.map(path => path.replace(/\//g, '.'))
}
